import { ConfigFilterItem, ConfigItem } from 'Core/interfaces'

export enum BackupDocumentSearchSuggestions {
	transactionId = 'transactionIds',
	serviceOccurrenceId = 'serviceOccurrenceIds'
}

export enum BackupDocumentFilterFields {
	startDate = 'startDate',
	endDate = 'endDate',
	serviceSite = 'serviceSite'
}

export declare namespace BackupDocument {
	interface Basic {
		transactionId: number
		serviceOccurrenceId: number
		serviceSite: Entity | null
		serviceDate: BasicString
		document: BasicString
		documentType: NullableEntity
	}

	namespace Search {
		interface Config {
			[BackupDocumentSearchSuggestions.transactionId]: ConfigItem<BackupDocumentSearchSuggestions>
			[BackupDocumentSearchSuggestions.serviceOccurrenceId]: ConfigItem<BackupDocumentSearchSuggestions>
		}

		interface Result {
			[BackupDocumentSearchSuggestions.transactionId]: number[]
			[BackupDocumentSearchSuggestions.serviceOccurrenceId]: number[]
		}
	}

	namespace Filter {
		interface Config {
			[BackupDocumentFilterFields.startDate]: ConfigFilterItem<string, null>
			[BackupDocumentFilterFields.endDate]: ConfigFilterItem<string, null>
			[BackupDocumentFilterFields.serviceSite]: ConfigFilterItem<string, string>
		}
	}
}
